import React from 'react';

function RenderNormalSelect({
  input,
  className,
  disabled,
  opts,
  meta: { touched, error },
}) {
  return (
    <select
      {...input}
      className={className}
      style={{
        borderColor: `${touched && error ? '#FF0000' : '#c6cbd2'}`,
      }}
      disabled={disabled}
    >
    <option value="">-- Chọn tỉnh thành --</option>
      {opts &&
        opts.map((item, index) => (
          <option key={index} value={item.C_CODE}>
            {item.C_NAME}
          </option>
        ))}
    </select>
  );
}

export default RenderNormalSelect;
